import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { SvgCross, SvgLeftAngle, SvgRightAngle } from './svg'
import { Mbr } from './br'
import { useSettings } from '../hooks/use-settings'

const Outer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`

const Bg = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  backdrop-filter: blur(1rem);
  background-color: #0008;
`

const Inner = styled.div`
  position: relative;
  padding: 3rem 2rem 2rem 2rem;
  background-color: white;
  margin: var(--page-margin);
  @media (max-width: 40rem){
    padding: 3rem 1.5rem 1.5rem 1.5rem;
  }
`

const CloseButton = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 1rem;
  cursor: pointer;
  svg {
    display: block;
    height: 1.5rem;
    width: 1.5rem;
  }
`

const Content = styled.div``

const ImageContainer = styled.div`
  img {
    display: block;
    height: 3rem;
    width: auto;
    margin-left: auto;
    margin-right: auto;
  }
`

const Text = styled.div`
  font-size: 0.9375rem;
  line-height: 1.6;
  text-align: center;
  margin-top: 2rem;
  @media (max-width: 40rem){
    font-size: 0.8rem;
    line-height: 1.8;
  }

  span {
    word-break: break-all;
  }
`

const ButtonContainer = styled.div`
  margin-top: 1.5rem;
  display: flex;
  gap: 1rem;
  justify-content: center;
`

const Button = styled.a`
  display: block;
  padding: 0.75rem 1.5rem;
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 0.5rem;
  color: var(--blue);
  border: 1px solid currentColor;
  font-size: 0.8rem;
  cursor: pointer;
  svg {
    display: block;
    height: 1em;
    width: auto;
    min-width: 0;
  }
`

type PopupProps = {
  onClose: () => void
  data: {
    siteName: string,
    url: string
  }
}
export const Popup: FunctionComponent<PopupProps> = ({onClose, data}) => {
  const {themeRoot} = useSettings()
  return <Outer>
    <Bg onClick={() => onClose()}/>
    <Inner>
      <CloseButton onClick={() => onClose()}>
        <SvgCross />
      </CloseButton>
      <Content>
        <ImageContainer>
          <img src={`${themeRoot}/images/diners-logo.webp`} />
        </ImageContainer>
        <Text>
          「<span>{data.siteName}</span>」<Mbr />へ移動します。<br />
          このサイトに移動する場合には<Mbr />「進む」をクリックしてください。
        </Text>
        <ButtonContainer>
          <Button onClick={() => onClose()}>
            <SvgLeftAngle />
            戻る
          </Button>
          <Button href={data.url} target="_blank" onClick={() => onClose()}>
            進む
            <SvgRightAngle />
          </Button>
        </ButtonContainer>
      </Content>
    </Inner>
  </Outer>
}